import { Vue, Component, toNative } from 'vue-facing-decorator';
import BadgesTable from 'components/BadgesTable';
import { useRouter } from 'vue-router';
import Template from './template.vue';

@Component({
	components: {
		BadgesTable,
	},
	mixins: [Template],
})
class Badges extends Vue {
	private router = useRouter();

	showModal(): void {
		this.$root?.$emit(
			'bv::show::modal',
			'bv-modal',
			'#btnShow',
		);
	}

	routeBadge(id: string): void {
		this.router.push(`/badges/${id}`);
	}
}

export default toNative(Badges);
